<template>
  <a-drawer
    title="消息类型组"
    class="small"
    v-model:open="groupState.visible"
    width="60%"
  >
    <message-group-table />
    <message-group-edit-modal />
  </a-drawer>
</template>

<script>
import { inject, provide, reactive, defineExpose } from 'vue'
import MessageGroupTable from './Table.vue'
import MessageGroupEditModal from './EditModal.vue'
import {
  delete_message_type_group,
  query_message_type_group_list
} from 'server/modules/message'
import { message } from 'ant-design-vue'

export default {
  name: 'SiteMessageGroupDrawer',
  components: { MessageGroupEditModal, MessageGroupTable },
  setup() {
    const state = inject('state')
    const groupState = reactive({
      visible: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      dataList: [],
      columns: [
        {
          title: '消息类型组',
          dataIndex: 'groupName',
          width: 150,
          slots: { customRender: 'groupName' }
        },
        {
          title: '创建人',
          dataIndex: 'createUser',
          width: 100
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 100
        },
        {
          title: '更新人',
          dataIndex: 'updateUser',
          width: 100
        },
        {
          title: '更新时间',
          dataIndex: 'lastUpdateTime',
          width: 100
        },
        {
          title: '操作',
          dataIndex: 'deal',
          width: 100,
          fixed: 'right',
          slots: { customRender: 'deal' }
        }
      ],
      edit: {
        visible: false,
        title: null,
        param: {
          groupCode: null,
          groupName: null
        }
      },
      // 修改页码
      changePage: pageNum => {
        state.pageNum = pageNum
        groupState.getList()
      },
      onShowSizeChange: (current, pageSize) => {
        state.pageNum = current
        state.pageSize = pageSize
        groupState.getList()
      },
      showDrawer: () => {
        groupState.visible = true
        groupState.getList()
      },
      getList: async () => {
        const { success, retInfo, data } = await query_message_type_group_list({
          ...{
            pageNum: groupState.pageNum,
            pageSize: groupState.pageSize
          }
        })

        if (success) {
          groupState.dataList = data.list
          groupState.total = data.total
        } else {
          message.error(retInfo)
        }
      },
      showEdit: record => {
        groupState.edit.visible = true
        groupState.edit.title = record ? '编辑消息类型组' : '新增消息类型组'
        groupState.edit.param = {
          groupCode: record?.groupCode || null,
          groupName: record?.groupName || null
        }
      },
      onDeleted: async messageGroupCode => {
        const { success, retInfo } = await delete_message_type_group({
          groupCode: messageGroupCode
        })
        if (success) {
          groupState.getList()
        } else {
          message.error(retInfo)
        }
      }
    })

    provide('groupState', groupState)

    defineExpose({
      showDrawer: groupState.showDrawer
    })

    return {
      state,
      groupState
    }
  }
}
</script>

<style scoped></style>
